import * as React from "react";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderGCPNodePool } from "./nodePool";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

type RouteParams = "index";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderGCPNodePoolContainerRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const { pathname } = useLocation();

  const { index: indexStr } = useParams<RouteParams>();
  const index = Number(indexStr);

  const g = mk8sDraft.provider_gcp;
  const np = g.nodePools.find((np) => np.index === index);

  if (!np) {
    return <Navigate to={`${pathname.split("/-node-pools")[0]}/-node-pools`} />;
  }

  return (
    <ProviderGCPNodePool
      mk8s={mk8s}
      mk8sDraft={mk8sDraft}
      gcp={g}
      nodePool={np}
      index={index}
    />
  );
};

export const ProviderGCPNodePoolContainer = observer(ProviderGCPNodePoolContainerRaw);
